import { gql } from "@apollo/client";

// ========== PhoneSystemDashboard Queries ==========

export const GET_MY_ASSIGNED_NUMBERS = gql`
  query GetMyAssignedPhoneNumbers {
    myAssignedPhoneNumbers {
      id
      phoneNumber
      friendlyName
      forwardToNumber
      status
      recordCalls
      autoTranscribe
      capabilities
      monthlyCost
      currency
      locality
      region
      isoCountry
      lastUsedAt
      isAssigned
      associatedClients
    }
  }
`;

export const GET_ME = gql`
  query Me {
    me {
      id
      email
      fName
      lName
      phoneNumber
    }
  }
`;

export const SETUP_CALL_FORWARDING = gql`
  mutation SetupCallForwarding($phoneNumberId: ID!, $forwardToNumber: String!, $recordCalls: Boolean) {
    setupCallForwarding(phoneNumberId: $phoneNumberId, forwardToNumber: $forwardToNumber, recordCalls: $recordCalls) {
      id
      phoneNumber
      forwardToNumber
      recordCalls
      status
    }
  }
`;

export const DISABLE_CALL_FORWARDING = gql`
  mutation DisableCallForwarding($phoneNumberId: ID!) {
    disableCallForwarding(phoneNumberId: $phoneNumberId) {
      id
      phoneNumber
      forwardToNumber
      status
    }
  }
`;

export const SYNC_TWILIO_NUMBERS = gql`
  mutation SyncTwilioNumbers {
    syncTwilioNumbers {
      id
      phoneNumber
      friendlyName
      status
      capabilities
    }
  }
`;

// ========== CallRecordings Queries ==========

export const GET_CALL_RECORDINGS = gql`
  query GetCallRecordings($filter: CallRecordingFilterInput, $page: Int, $limit: Int) {
    callRecordings(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        recordingSid
        callSid
        from
        to
        duration
        direction
        status
        recordingUrl
        pinataUrl
        transcriptionStatus
        transcriptionText
        transcriptionConfidence
        recordedAt
        phoneNumber {
          id
          phoneNumber
          friendlyName
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const TRANSCRIBE_RECORDING = gql`
  mutation TranscribeRecording($recordingSid: String!) {
    transcribeRecording(recordingSid: $recordingSid) {
      id
      transcriptionStatus
      transcriptionText
    }
  }
`;

export const DOWNLOAD_RECORDING_URL = gql`
  mutation DownloadRecordingUrl($recordingSid: String!) {
    downloadRecordingUrl(recordingSid: $recordingSid)
  }
`;

export const DELETE_RECORDING = gql`
  mutation DeleteRecording($id: ID!) {
    deleteRecording(id: $id)
  }
`;

export const SYNC_CALL_RECORDINGS = gql`
  mutation SyncCallRecordings($phoneNumberId: ID, $days: Int) {
    syncCallRecordings(phoneNumberId: $phoneNumberId, days: $days)
  }
`;

export const TRANSCRIBE_ALL_RECORDINGS = gql`
  mutation TranscribeAllRecordings {
    transcribeAllRecordings
  }
`;

// ========== PhoneNumbersList Queries ==========

export const GET_PHONE_NUMBERS = gql`
  query GetPhoneNumbers {
    phoneNumbers {
      id
      phoneNumber
      friendlyName
      forwardToNumber
      status
      capabilities
      recordCalls
      autoTranscribe
      monthlyCost
      currency
      locality
      region
      purchasedAt
      lastUsedAt
    }
  }
`;

export const SEARCH_AVAILABLE_NUMBERS = gql`
  query SearchAvailablePhoneNumbers(
    $country: String!
    $areaCode: String
    $contains: String
    $capabilities: [PhoneCapability!]
    $limit: Int
  ) {
    searchAvailablePhoneNumbers(
      country: $country
      areaCode: $areaCode
      contains: $contains
      capabilities: $capabilities
      limit: $limit
    ) {
      phoneNumber
      friendlyName
      locality
      region
      capabilities
      monthlyCost
      currency
    }
  }
`;

export const PURCHASE_PHONE_NUMBER = gql`
  mutation PurchasePhoneNumber($input: PurchasePhoneNumberInput!) {
    purchasePhoneNumber(input: $input) {
      id
      phoneNumber
      friendlyName
      status
    }
  }
`;

export const UPDATE_PHONE_NUMBER = gql`
  mutation UpdatePhoneNumber($id: ID!, $input: TwilioPhoneNumberInput!) {
    updatePhoneNumber(id: $id, input: $input) {
      id
      phoneNumber
      friendlyName
      forwardToNumber
      recordCalls
      autoTranscribe
    }
  }
`;

export const RELEASE_PHONE_NUMBER = gql`
  mutation ReleasePhoneNumber($id: ID!) {
    releasePhoneNumber(id: $id)
  }
`;

// ========== PhoneNumberAssignmentAdmin Queries ==========

export const GET_PHONE_NUMBERS_FOR_ASSIGNMENT = gql`
  query GetPhoneNumbers {
    phoneNumbers {
      id
      phoneNumber
      friendlyName
      status
      capabilities
      isAssigned
      associatedClients
      assignedAt
      locality
      region
    }
  }
`;

export const GET_CLIENTS = gql`
  query GetClients {
    clients {
      id
      fName
      lName
      email
      phoneNumber
      profilePhoto
    }
  }
`;

export const ASSIGN_PHONE_NUMBER = gql`
  mutation AssignPhoneNumberToClient($phoneNumberId: ID!, $clientId: ID!) {
    assignPhoneNumberToClient(phoneNumberId: $phoneNumberId, clientId: $clientId) {
      id
      phoneNumber
      isAssigned
      associatedClients
    }
  }
`;

export const UNASSIGN_PHONE_NUMBER = gql`
  mutation UnassignPhoneNumberFromClient($phoneNumberId: ID!, $clientId: ID!) {
    unassignPhoneNumberFromClient(phoneNumberId: $phoneNumberId, clientId: $clientId) {
      id
      phoneNumber
      isAssigned
      associatedClients
    }
  }
`;

// ========== BrowserCall Queries ==========

export const GET_TWILIO_TOKEN = gql`
  query GetTwilioAccessToken {
    getTwilioAccessToken
  }
`;

export const GET_USER_PHONE_NUMBERS = gql`
  query GetUserAssignedPhoneNumbers {
    userAssignedPhoneNumbers {
      id
      phoneNumber
      friendlyName
      status
    }
  }
`;
